import { apiFetch } from "./client";

export interface CostEvent {
  id: string;
  companyId: string;
  agentId: string | null;
  eventType: string;
  amountCents: number;
  description: string | null;
  metadata: Record<string, unknown> | null;
  createdAt: string;
}

export interface CostSummary {
  totalCents: number;
  totalDollars: number;
  eventCount: number;
}

export const costsApi = {
  list: (companyId: string) => apiFetch<CostEvent[]>(`/costs?companyId=${companyId}`),
  summary: (companyId: string) => apiFetch<CostSummary>(`/costs/summary?companyId=${companyId}`),
};
